export const commonItIt = {
  brand: {
    logoAlt: 'Logo Safi',
    name: 'Safi',
    vatLabel: 'Safi IVA',
  },
  domains: {
    evidence: 'Prove',
    evidenceLower: 'prove',
    qualityControl: 'Controllo qualità',
    qualityControlLower: 'controllo qualità',
  },
  currencySelectField: {
    groups: {
      other: 'Altro',
      suggested: 'Suggerito',
    },
  },
} as const;
